import { getFirestore, doc, getDoc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { useEffect, useState } from "react";
import { firebaseApp } from "../../system/firebase";
import { TopBar } from "../../_shared/TopBar";
import Lottie from "lottie-react";
import anim from "../../assets/anim/success.json";

const RouteConferencePayment = () => {
    const [screen, setScreen] = useState(0);
    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState(null);
    const [subscriber, setSubscriber] = useState(null);
    const [subscriberDocId, setSubscriberDocId] = useState(null);
    const [file, setFile] = useState(null);
    const [paymentProof, setPaymentProof] = useState("");
    const db = getFirestore(firebaseApp);
    const storage = getStorage(firebaseApp);

    // Get id and email from url
    const id = window.location.pathname.split("/")[2];
    const queryParams = new URLSearchParams(window.location.search);
    const email = queryParams.get("email");

    useEffect(() => {
        if (!id) return;

        // Fetch event from Firestore
        getDoc(doc(db, 'ALL_EVENTS', id)).then((snap) => {
            if (snap.exists()) setEvent({ id: snap.id, ...snap.data() });
        });

        // Fetch subscriber from ALL_SUBSCRIBERS
        if (email) {
            const q = query(
                collection(db, 'ALL_SUBSCRIBERS'),
                where('eventId', '==', id),
                where('email', '==', email.toLowerCase().trim())
            );
            getDocs(q).then((snapshot) => {
                if (!snapshot.empty) {
                    const docSnap = snapshot.docs[0];
                    setSubscriber(docSnap.data());
                    setSubscriberDocId(docSnap.id);
                }
            });
        }
    }, [id, email]);

    const handleFileUpload = async (file, path) => {
        const fileRef = storageRef(storage, path);
        await uploadBytes(fileRef, file);
        return getDownloadURL(fileRef);
    };

    const handleSubmit = async () => {
        if (!paymentProof.trim()) {
            alert("Please provide payment reference or proof");
            return;
        }
        if (!subscriberDocId) {
            alert("Could not find your registration. Please re-check your link.");
            return;
        }
        setLoading(true);
        try {
            let abstractUrl = "";
            if (file) {
                abstractUrl = await handleFileUpload(file, `CONFERENCES/${id}/ABSTRACTS/${subscriberDocId}_${file.name}`);
            }

            await updateDoc(doc(db, 'ALL_SUBSCRIBERS', subscriberDocId), {
                paymentReference: paymentProof,
                abstractUrl: abstractUrl || null,
                status: "completed"
            });

            setScreen(1);
        } catch (error) {
            console.error(error);
            alert("An error occurred. Please try again.");
        }
        setLoading(false);
    };

    return (
        <div className="screen-webinars">
            <TopBar />
            {screen === 0 && (
                <div className="webinar-rl">
                    <div className="box-root padding-bottom--24 flex-flex flex-justifyContent--center">
                        <h1 className="top-title">Payment &amp; Abstract Submission</h1>
                    </div>
                    <h2>{event?.name}</h2>
                    <p>Welcome back, {subscriber?.name}. Please complete your registration.</p>

                    <div className="formbg-outer">
                        <div className="formbg">
                            <div className="formbg-inner padding-horizontal--48">
                                <form id="registration-complete" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                    <div className="field padding-bottom--24">
                                        <label>Registration Fee</label>
                                        <div className="payment-fee-display">
                                            {subscriber?.presenceType === 'in-person' ? (event?.physicalFee || 'TBA') : (event?.virtualFee || 'TBA')}
                                        </div>
                                    </div>

                                    <div className="field padding-bottom--24">
                                        <label htmlFor="payment">Payment Reference / Transaction ID</label>
                                        <input
                                            type="text"
                                            name="payment"
                                            placeholder="Enter M-Pesa or Bank reference"
                                            value={paymentProof}
                                            onChange={(e) => setPaymentProof(e.target.value)}
                                        />
                                    </div>

                                    <div className="field padding-bottom--24">
                                        <label htmlFor="abstract">Upload Abstract (Optional)</label>
                                        <input
                                            type="file"
                                            name="abstract"
                                            onChange={(e) => setFile(e.target.files[0])}
                                        />
                                    </div>

                                    <div className="field padding-bottom--24">
                                        <input type="submit" name="submit" value="Submit Registration" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {screen === 1 && (
                <div className="webinar-rl">
                    <div className="success-image">
                        <Lottie animationData={anim} />
                    </div>
                    <div className="box-root padding-bottom--24 flex-flex flex-justifyContent--center">
                        <h1 className="top-title">Submission Successful!</h1>
                    </div>
                    <p className="iinfo">Thank you for completing your registration. We will review your payment and abstract and get back to you shortly.</p>
                    <a className="meeting-link" href="/">Go back to Home</a>
                </div>
            )}

            {loading && (
                <div className="modal-bg">
                    <div className="">
                        <div className="lds-spinner spinner-orange" style={{ margin: 0 }}>
                            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
                        </div>
                        <h3>Processing...</h3>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RouteConferencePayment;
